/**
 * Development deploy environment (Jenkins BUILD_TYPE=dev).
 *
 * URLs are PLACEHOLDERS that get replaced at deploy time by `inject-network`
 * (see inject.network.config.js + networks.json). HOST_NETWORK in the deploy
 * job picks which set of real URLs gets substituted:
 *   INTERNAL_NETWORK → rest.tsrv.ebuero.de   (test)
 *   EXTERNAL_NETWORK → rest.office-platform.net (live)
 *
 * `production: false` keeps Angular's dev-friendly behavior (verbose errors).
 * For LOCAL `nx serve`, see environment.ts (no file replacement applied).
 */
export const environment = {
  production: false,

  // EB-3796: Replaced by `inject-version` at deploy (analog to *_URL_PLACEHOLDER).
  appVersion: 'VERSION_PLACEHOLDER',

  authUrl: 'EBUERO_AUTH_URL_PLACEHOLDER',

  bookingUrl: 'EBUERO_API_URL_PLACEHOLDER/booking/v2',
  bookingMgmtUrl: 'EBUERO_API_URL_PLACEHOLDER/bookingmgmt/v2',
  contractUrl: 'EBUERO_API_URL_PLACEHOLDER/contract/v2/rest',
  customerUrl: 'EBUERO_API_URL_PLACEHOLDER/customer/v2',
  documentUrl: 'EBUERO_API_URL_PLACEHOLDER/document/v1',
  invoiceUrl: 'EBUERO_API_URL_PLACEHOLDER/invoice/v1',
  localizationV1Url: 'EBUERO_API_URL_PLACEHOLDER/localization/v1',
  localizationV2Url: 'EBUERO_API_URL_PLACEHOLDER/localization/v2',
  phoneServiceUrl: 'EBUERO_API_URL_PLACEHOLDER/phoneservice/v3',
  searchUrl: 'EBUERO_API_URL_PLACEHOLDER/internalsearch/v1',
  transcriptionUrl: 'EBUERO_API_URL_PLACEHOLDER/transcription/v1',
  userAccountUrl: 'EBUERO_API_URL_PLACEHOLDER/useraccount/v1',
  // EB-3798: customersupport-api — frontend-log bridge (BE forwards to Graylog).
  // Standard API host per HOST_NETWORK, so the internal syslog host stays
  // server-side (never in the client/CSP). See LoggingService.
  customerSupportUrl: 'EBUERO_API_URL_PLACEHOLDER/customersupport/v1',

  oldPortalUrl: 'EBUERO_OLD_PORTAL_URL_PLACEHOLDER',
  portalEnvKey: 'EBUERO_PORTAL_ENV_KEY_PLACEHOLDER',
  staticCdnUrl: 'EBUERO_STATIC_URL_PLACEHOLDER',

  // EB-3595: Service Management Tool (SMT) iframe base. Substituted by
  // inject-network per HOST_NETWORK (see networks.json test_smt / live_smt):
  //   INTERNAL_NETWORK → https://tools.test.office-platform.net/service-management-tool/
  //   EXTERNAL_NETWORK → https://tools.office-platform.net/service-management-tool/
  // Both same-site with AMIE (*.office-platform.net) → SMT silent-auths in the frame.
  smtUrl: 'EBUERO_SMT_URL_PLACEHOLDER',

  // EB-3805: Routing Manager — Call Explainer deep-link. Substituted by
  // inject-network per HOST_NETWORK:
  //   INTERNAL_NETWORK → https://routingmgr.tsrv.ebuero.de
  //   EXTERNAL_NETWORK → https://routingmgr.coast.ebuero.de
  // Requires the placeholder mapping in the deploy-pipeline networks config.
  routingManagerUrl: 'EBUERO_ROUTINGMGR_URL_PLACEHOLDER',

  // EB-3807: Graylog search endpoint — "Open Graylog" deep-link. Single central
  // Graylog instance (https://graylog2web.coast.ebuero.de/search) for both test
  // and live; substituted by inject-network. Requires the placeholder mapping in
  // the deploy-pipeline networks config.
  graylogUrl: 'EBUERO_GRAYLOG_URL_PLACEHOLDER',
  // EB-4196: TAPStore recordings. AD-10: one store for all envs, so a literal
  // rather than a placeholder (same as graylogStreamId).
  tapStoreUrl: 'https://tapstore.coast.ebuero.de/recordings',

  // EB-3807: Graylog stream the Call Details deep-link scopes to (same test+live).
  graylogStreamId: '68ee5b1b6e80da6587f99938',
};
